export default () => {
    return {
        isFetching: false,
        merchantPreOrders: [],
        errors: {}
    };
};
